<template>
  <router-link :to="reportData.to" class="report-card">
    <div class="report-card__body">
      <div v-if="reportData.premium" class="report-card__premium">
        <GkBadge :text="$gettext('Premium')" icon="fa-solid fa-crown" type="premium" variant="base" />
      </div>
      <div class="report-card__icon">
        <font-awesome-icon :icon="`fa-solid ${reportData.icon}`" />
      </div>
      <div>
        <div class="report-card__title">
          {{ reportData.title }}
        </div>
        <div class="report-card__description">
          {{ reportData.description }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ReportLinkCard',
  props: {
    reportData: { type: [Object], required: true },
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
    }),
  },
}
</script>

<style lang="scss" scoped>
.report-card {
  padding: 1rem;
  border-radius: 1rem;
  position: relative;
  border: 1px solid transparent;
  box-shadow: $filtersShadow;
  &:hover {
    text-decoration: none;
    border: 1px solid $colorBrand800;
    .report-card__icon {
      color: $colorBrand800;
    }
  }
  &__premium {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
  &__body {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  &__icon {
    color: $colorBrand;
    font-size: 30px;
  }
  &__title {
    color: $colorTextBase;
    font-size: 18px;
  }
  &__description {
    color: $colorTextSemi;
    font-size: 1rem;
  }
}
</style>